var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSources({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#3079F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.25C32.5967 34.25 33.169 34.0129 33.591 33.591C34.0129 33.169 34.25 32.5967 34.25 32C34.25 31.4033 34.0129 30.831 33.591 30.409C33.169 29.9871 32.5967 29.75 32 29.75C31.4033 29.75 30.831 29.9871 30.409 30.409C29.9871 30.831 29.75 31.4033 29.75 32C29.75 32.5967 29.9871 33.169 30.409 33.591C30.831 34.0129 31.4033 34.25 32 34.25ZM50 32C50 36.7739 48.1036 41.3523 44.7279 44.7279C41.3523 48.1036 36.7739 50 32 50C27.2261 50 22.6477 48.1036 19.2721 44.7279C15.8964 41.3523 14 36.7739 14 32C14 27.2261 15.8964 22.6477 19.2721 19.2721C22.6477 15.8964 27.2261 14 32 14C36.7739 14 41.3523 15.8964 44.7279 19.2721C48.1036 22.6477 50 27.2261 50 32ZM26.6157 28.607L23.081 39.2112C23.0011 39.4492 22.9892 39.7048 23.0465 39.9492C23.1038 40.1936 23.2282 40.4172 23.4056 40.5948C23.583 40.7725 23.8064 40.8971 24.0507 40.9548C24.2951 41.0124 24.5507 41.0008 24.7888 40.9213L35.393 37.3842C35.8566 37.2296 36.2779 36.9691 36.6235 36.6235C36.9691 36.2779 37.2296 35.8566 37.3842 35.393L40.919 24.7888C40.9989 24.5508 41.0108 24.2952 40.9535 24.0508C40.8962 23.8064 40.7718 23.5828 40.5944 23.4052C40.417 23.2275 40.1936 23.1029 39.9493 23.0452C39.7049 22.9876 39.4493 22.9992 39.2112 23.0787L28.607 26.618C28.1434 26.7727 27.7221 27.0331 27.3765 27.3787C27.0309 27.7243 26.7704 28.1434 26.6157 28.607Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.0347257a168297d036170325ddd23ffa.svg";
export { ForwardRef as ReactComponent };